// extracted by mini-css-extract-plugin
export default {"topbar":"TopBar_topbar__5VNYp","userName":"TopBar_userName__WkuWP","title":"TopBar_title__aC-vz","burgerContainer":"TopBar_burgerContainer__zaU5D","burger":"TopBar_burger__Q5x1z"};